import { system } from 'styled-system';
import { transparentize } from 'polished';

export const backgroundColor = system({
  backgroundColor: {
    property: 'background',
    scale: 'colors',
    transform: (value, scale) => {
      const hexColor = value
        .split('.')
        .reduce(
          (previous: Record<string, string>, current: string) =>
            previous[current],
          scale
        );
      if (!hexColor) return;
      return `linear-gradient(180deg, ${transparentize(
        0.5,
        hexColor
      )} 0%, ${transparentize(0.8, hexColor)} 100%)`;
    },
  },
});
